import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
type Purchase = {
  name: string;
  city: string;
  country: string;
};
const purchases: Purchase[] = [{
  name: 'Carla Mendoza',
  city: 'Santiago',
  country: 'Chile'
}, {
  name: 'Roberto Fuentes',
  city: 'Valparaíso',
  country: 'Chile'
}, {
  name: 'Alejandra Rojas',
  city: 'Concepción',
  country: 'Chile'
}, {
  name: 'Diego Morales',
  city: 'Ciudad de México',
  country: 'México'
}, {
  name: 'Sofía García',
  city: 'Guadalajara',
  country: 'México'
}, {
  name: 'Miguel Hernández',
  city: 'Monterrey',
  country: 'México'
}, {
  name: 'Valentina López',
  city: 'Bogotá',
  country: 'Colombia'
}, {
  name: 'Andrés Castillo',
  city: 'Medellín',
  country: 'Colombia'
}, {
  name: 'Natalia Sánchez',
  city: 'Cali',
  country: 'Colombia'
}, {
  name: 'Javier Quispe',
  city: 'Lima',
  country: 'Perú'
}, {
  name: 'Mariana Flores',
  city: 'Arequipa',
  country: 'Perú'
}, {
  name: 'Carlos Vega',
  city: 'Cusco',
  country: 'Perú'
}, {
  name: 'Lucía Martínez',
  city: 'Montevideo',
  country: 'Uruguay'
}, {
  name: 'Gonzalo Silva',
  city: 'Punta del Este',
  country: 'Uruguay'
}, {
  name: 'Fernanda Díaz',
  city: 'Salto',
  country: 'Uruguay'
}];
const INITIAL_DELAY = 15_000;
const DISPLAY_DURATION = 4_500;
const REPEAT_INTERVAL = 90_000;
export function SocialProofPopup() {
  const prefersReducedMotion = useReducedMotion();
  const lastPurchaseIndex = useRef(-1);
  const hideTimeout = useRef<number | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState<Purchase>(purchases[0]);
  const scrollToCompra = () => {
    setIsVisible(false);
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    const showPopup = () => {
      let nextIndex = Math.floor(Math.random() * purchases.length);
      if (nextIndex === lastPurchaseIndex.current) {
        nextIndex = (nextIndex + 1) % purchases.length;
      }
      lastPurchaseIndex.current = nextIndex;
      setCurrentPurchase(purchases[nextIndex]);
      setIsVisible(true);
      if (hideTimeout.current) window.clearTimeout(hideTimeout.current);
      hideTimeout.current = window.setTimeout(() => {
        setIsVisible(false);
      }, DISPLAY_DURATION);
    };
    const initialDelay = window.setTimeout(showPopup, INITIAL_DELAY);
    const interval = window.setInterval(showPopup, REPEAT_INTERVAL);
    return () => {
      window.clearTimeout(initialDelay);
      window.clearInterval(interval);
      if (hideTimeout.current) window.clearTimeout(hideTimeout.current);
    };
  }, []);
  return <AnimatePresence data-id="element-345" data-mp="2essfudwet7lw">
      {isVisible && <motion.aside initial={prefersReducedMotion ? false : {
      y: -12,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={prefersReducedMotion ? {
      opacity: 0
    } : {
      y: -8,
      opacity: 0
    }} transition={{
      duration: prefersReducedMotion ? 0.01 : 0.18,
      ease: [0.22, 1, 0.36, 1]
    }} role="status" aria-live="polite" className="fixed left-3 right-3 top-[8.25rem] z-40 mx-auto max-w-sm md:left-auto md:right-4 md:top-24 md:max-w-xs" data-id="element-346" data-mp="2erqungloj4qg">
          <div className="flex items-start gap-2 rounded-xl border border-[#9C16A3]/60 bg-[#121212] p-2.5 shadow-[0_8px_28px_rgba(0,0,0,0.38)] md:p-3" data-id="element-347" data-mp="356tjkeygwc5">
            <div className="shrink-0 rounded-full bg-[#9C16A3]/20 p-1.5" data-id="element-348" data-mp="vu49hgvp2h1q">
              <ShoppingBagIcon className="h-3.5 w-3.5 text-[#FC9DFF] md:h-4 md:w-4" aria-hidden="true" data-id="element-349" data-mp="quhx19nox4tz" />
            </div>

            <button type="button" onClick={scrollToCompra} className="min-w-0 flex-1 rounded-sm text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FC9DFF]" data-id="element-350" data-mp="luvhgtke3ci0">
              <p className="text-[10px] font-black text-white md:text-xs" data-id="element-351" data-mp="36n7497bwbftg">
                Acceso reciente
              </p>
              <p className="truncate text-[10px] leading-4 text-gray-300 md:text-xs" data-id="element-352" data-mp="31onib6xay413">
                <span className="font-semibold text-white" data-id="element-353" data-mp="ua1cgq01gdka">{currentPurchase.name}</span>
                {' · '}
                {currentPurchase.city}, {currentPurchase.country}
              </p>
              <p className="text-[9px] text-[#FC9DFF] md:text-[10px]" data-id="element-354" data-mp="kezm5qu115g4">
                Se unió a Dominando Shopify hace unos minutos
              </p>
            </button>

            <button type="button" onClick={() => setIsVisible(false)} className="shrink-0 rounded p-1 text-gray-400 transition-colors duration-150 hover:text-[#FC9DFF] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FC9DFF]" aria-label="Cerrar notificación" data-id="element-355" data-mp="1d2vi2tbrutbu">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-356" data-mp="184tx22uscjxq" />
            </button>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}